<script>
export default {
    name: 'Announcement',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            centerDialogVisible: this.visible,
            isTermsAccepted: true
        }
    },
    watch: {
        visible (newVal) {
            this.centerDialogVisible = newVal
        }
    },
    methods: {
        handleAgree () {
            this.$emit('update:status', true)
        },
        handleDisagree () {
            this.$emit('update:status', false)
        }
    }
}
</script>

<template>
    <el-dialog
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        custom-class="announce"
        destroy-on-close
        center
        @close="handleAgree"
    >
        <div
            slot="title"
            class="announce-header"
        >
            关于《企业会员服务协议》更新通知
        </div>
        <div class="announce-body">
            <p>尊敬的用户，您好！</p>
            <p class="content-text">
                感谢您使用金穗智管的产品及服务，我们于近期发布了新版《企业会员协议》，新版将于2024年6月12日正式生效，生效后金穗智管产品及服务按新版执行，感谢您对金穗智管的使用和支持，若对协议更新有疑问，请联系客户经理，我们将诚为您服务!
            </p>
            <p class="content-text">
                更新后的协议内容，您可以点击查看:
                <router-link
                    to="/terms"
                    target="_blank"
                >
                    <el-link
                        underline
                        type="primary"
                        style="text-indent: 0;"
                    >
                        《企业会员协议》
                    </el-link>
                </router-link>
            </p>
        </div>
        <div
            slot="footer"
        >
            <p style="line-height: 1.2;margin-block-start: 1em;font-size: 14px;">
                此致
                <br>
                <strong>金穗智管团队</strong>
            </p>
        </div>
    </el-dialog>
</template>

<style scoped lang="scss">

</style>
